export enum AddressTypes {
  Supplier = 'Supplier',
  Customer = 'Customer',
  Tenant = 'Tenant',
  Employee = 'Employee',
  Investor = 'Investor',
  Address = 'Address',
  Agency = 'Agency',
  AgencyRealtor = 'AgencyRealtor',
  Individual = 'Individual',
  SalesOffice = 'SalesOffice',
  Company = 'Company',
  OUnitCodes = 'OUnitCodes'
}

export const ADDRESS_TYPES = Object.values(AddressTypes);

export const ADDRESS_TYPE_OPTIONS = ADDRESS_TYPES.map(type => ({
  value: type,
  label: type
}));
